import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, Link, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import UrlIcon from "@iconify/icons-mdi/chevron-right";
import DotsVertical from "@iconify/icons-mdi/dots-vertical";
import DownloadIcon from "@iconify/icons-mdi/download";
import DocumentIcon from "@iconify/icons-mdi/file-document";
import PDFIcon from "@iconify/icons-mdi/file-pdf-box-outline";
import { InlineIcon } from "@iconify/react";
import { OcEditorMenu } from "oc/components";

interface OcDownloadProps {
  iconType: "pdf" | "document";
  label: string;
  href: string;
  actionIconType: "url" | "download";
  target?: string;
  createdAt?: string;
  badge?: string;
  isSmall?: boolean;
}

export const OcDownload: React.FC<OcDownloadProps> = ({
  iconType,
  label,
  href,
  actionIconType,
  target,
  createdAt,
  badge,
  isSmall,
}) => {
  let icon = iconType === "pdf" ? PDFIcon : DocumentIcon;
  let actionIcon = actionIconType === "url" ? UrlIcon : DownloadIcon;
  const theme = useTheme();
  const history = useHistory();

  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleModified = () => {
    setAnchorEl(null);
    history.push("/my-hr/my-profile");
  };

  const handleDelete = () => {
    setAnchorEl(null);
  };

  if (!href) return null;

  let height = "72px";

  if (isSmall) {
    height = "56px";
  }

  return (
    <>
      <OcEditorMenu
        handleClose={handleClose}
        handleModified={handleModified}
        handleDelete={handleDelete}
        anchorEl={anchorEl}
      />
      <Link
        id={label.replaceAll(" ", "_")}
        href={href}
        download={actionIconType === "url" ? false : true}
        style={{
          textDecoration: "none",
          padding: "0px",
          margin: "0px",
          outline: "none",
        }}
        target={target}
      >
        <Box
          height="40px"
          display="flex"
          flexDirection="row"
          alignItems="center"
          style={{
            height: height,
            backgroundColor: theme.palette.gray20.main,
            border: `1px solid ${theme.palette.gray40.main}`,
            display: "flex",
            borderRadius: "8px",
            color: theme.palette.darkBase.main,
          }}
        >
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            width="40px"
            height="40px"
            marginLeft="7px"
          >
            <InlineIcon icon={icon} width="20px" height="20px" />
          </Box>
          <Box flexGrow={1} display="flex" flexDirection="column">
            <Typography variant="body1">{label}</Typography>
            <Typography
              variant="caption"
              style={{
                color: "#919699",
              }}
            >
              {createdAt}
            </Typography>
          </Box>
          {badge && badge.length > 0 && (
            <>
              <Box
                style={{
                  border: `1px solid ${theme.palette.greenBase.main}`,
                  borderRadius: 12,
                  paddingLeft: 12,
                  paddingRight: 12,
                  paddingTop: 2,
                  paddingBottom: 2,
                  color: theme.palette.gray80.main,
                  fontSize: "14px",
                }}
              >
                {badge}
              </Box>
              <Box width="30px" />
              <Box onClick={handleClick}>
                <InlineIcon
                  icon={DotsVertical}
                  width="18px"
                  height="18px"
                  style={{ cursor: "pointer", color: "#4d4d4d" }}
                />
              </Box>
            </>
          )}
          <Box width="10px" />
          <Box
            id={`app-${href.slice(15)}`}
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            width="40px"
            height="40px"
            style={{
              cursor: "pointer",
              marginRight: "10px",
            }}
          >
            <InlineIcon
              icon={actionIcon}
              width="18px"
              height="18px"
              style={{ color: "#4d4d4d" }}
            />
          </Box>
        </Box>
      </Link>
    </>
  );
};

export default OcDownload;
